export const PRESERVED_QUERY_NAMESPACES = {
  TEMPLATE: 'template',
  INVITE: 'invite',
  SHARE: 'share',
  CREATE_WORKSPACE: 'create_workspace'
} as const
